import script from "./PixieDaily.vue?vue&type=script&setup=true&lang=js"
export * from "./PixieDaily.vue?vue&type=script&setup=true&lang=js"

import "./PixieDaily.vue?vue&type=style&index=0&id=65467bcd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65467bcd"]])

export default __exports__